import type {PublicMethodUtils} from '@wix/document-services-types'
import {feedback} from '@wix/document-services-implementation'

export default function (publicMethodUtils: PublicMethodUtils) {
    return {
        methods: {
            feedback: {
                comments: {
                    create: publicMethodUtils.defineAction(feedback.comments.create),
                    add: publicMethodUtils.defineAction(feedback.comments.add),
                    get: publicMethodUtils.defineGetter(feedback.comments.get),
                    remove: publicMethodUtils.defineAction(feedback.comments.remove),
                    markAsRead: publicMethodUtils.defineAction(feedback.comments.markAsRead)
                },
                isSiteShared: publicMethodUtils.defineGetter(feedback.isSiteShared),
                markSiteAsShared: publicMethodUtils.defineAction(feedback.markSiteAsShared)
            }
        }
    }
}
